import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import ProfileCard from "./ProfileCard";
import FloatingLabelInput from "../Generic/FloatingLabelInput";

const ProfileContactSection = ({
  form,
  setForm,
  updateProfileSection,
  validateSection,
}) => {
  const [editing, setEditing] = useState(false);

  const saveContact = async () => {
    if (!validateSection("contact", form)) return;
    await updateProfileSection({
      phone: form.phone,
      linkedin: form.linkedin,
      address: form.address,
    });

    setEditing(false);
  };

  return (
    <ProfileCard
      title="Contact"
      isEditing={editing}
      onEdit={() => setEditing(true)}
      onSave={saveContact}
      onCancel={() => setEditing(false)}
    >
      {!editing ? (
        <>
          <p>
            <strong>Email:</strong> {form.email}
          </p>
          <p>
            <strong>LinkedIn:</strong> {form.linkedin || "Not added"}
          </p>
          <p>
            <strong>Phone:</strong> {form.phone || "Not added"}
          </p>
          <p>
            <strong>Address:</strong>{" "}
            {form.address.street ||
            form.address.city ||
            form.address.state ||
            form.address.zip ||
            form.address.country
              ? `${form.address.street || ""}${
                  form.address.city ? ", " + form.address.city : ""
                }${form.address.state ? ", " + form.address.state : ""}${
                  form.address.zip ? ", " + form.address.zip : ""
                }${form.address.country ? ", " + form.address.country : ""}`
              : "Not added"}
          </p>
        </>
      ) : (
        <>
          {/* EMAIL (disabled) */}
          <div className="mb-3">
            <FloatingLabelInput
              label="Email"
              type="email"
              value={form.email}
              onChange={() => {}}
              disabled
            />
          </div>

          {/* LINKEDIN */}
          <div className="mb-3">
            <FloatingLabelInput
              label="LinkedIn URL"
              type="text"
              value={form.linkedin}
              onChange={(e) =>
                setForm((p) => ({ ...p, linkedin: e.target.value }))
              }
            />
          </div>

          {/* PHONE */}
          <div className="mb-3">
            <FloatingLabelInput
              label="Phone"
              type="tel"
              value={form.phone}
              onChange={(e) =>
                setForm((p) => ({ ...p, phone: e.target.value }))
              }
            />
          </div>

          {/* STREET (full width) */}
          <div className="mb-3">
            <FloatingLabelInput
              label="Street"
              type="text"
              value={form.address.street || ""}
              onChange={(e) =>
                setForm((p) => ({
                  ...p,
                  address: { ...p.address, street: e.target.value },
                }))
              }
            />
          </div>

          {/* CITY + STATE */}
          <Row>
            <Col>
              <div className="mb-3">
                <FloatingLabelInput
                  label="City"
                  type="text"
                  value={form.address.city || ""}
                  onChange={(e) =>
                    setForm((p) => ({
                      ...p,
                      address: { ...p.address, city: e.target.value },
                    }))
                  }
                />
              </div>
            </Col>
            <Col>
              <div className="mb-3">
                <FloatingLabelInput
                  label="State"
                  type="text"
                  value={form.address.state || ""}
                  onChange={(e) =>
                    setForm((p) => ({
                      ...p,
                      address: { ...p.address, state: e.target.value },
                    }))
                  }
                />
              </div>
            </Col>
          </Row>

          {/* ZIP + COUNTRY */}
          <Row>
            <Col>
              <div className="mb-2">
                <FloatingLabelInput
                  label="ZIP Code"
                  type="text"
                  value={form.address.zip || ""}
                  onChange={(e) =>
                    setForm((p) => ({
                      ...p,
                      address: { ...p.address, zip: e.target.value },
                    }))
                  }
                />
              </div>
            </Col>
            <Col>
              <div className="mb-2">
                <FloatingLabelInput
                  label="Country"
                  type="text"
                  value={form.address.country || ""}
                  onChange={(e) =>
                    setForm((p) => ({
                      ...p,
                      address: { ...p.address, country: e.target.value },
                    }))
                  }
                />
              </div>
            </Col>
          </Row>
        </>
      )}
    </ProfileCard>
  );
};

export default ProfileContactSection;
